import { Injectable } from '@angular/core';
import { SalesByProductsCollectionQuery, SalesByProductsCollectionQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByProductsCollectionQuery)
@Wrapper(SalesByProductsCollectionQueryHandlerBase)
export class SalesByProductsCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
